/** Sign-in error messages, and the reveal toggle secret fields share. */

export default {
	auth: {
		// The reveal toggle on a secret field (the control center's mail password, a license key).
		password: {
			show: "Show password",
			hide: "Hide password",
		},
		error: {
			login_expired:
				"Your sign-in could not be completed because it was no longer valid — for example, it took longer than 10 minutes or the server restarted in the meantime. Sign in again.",
			login_mismatch: "The sign-in could not be matched to this browser. Try again.",
			idp_error: "The identity provider reported an error. Try again.",
			email_conflict:
				"An account with this email address already exists under a different identity.",
			idp_unavailable: "The identity provider is currently unavailable. Try again shortly.",
			account_suspended: "Your account has been suspended on this server.",
			generic: "Sign-in failed. Try again.",
		},
	},
};
